module.exports = __webpack_public_path__ + "img/game_active.9bde1d72.png";